<template>
  <div class="jisaoList">
    <jisao-search></jisao-search>
    <div class="searchTitle">
      搜索结果
    </div>
    <!-- 'id', firstPhoto, 'tombCode', 'tombName', 'tombHole', 'gender', 'areaName', 'areaRow', 'areaCol' -->
    <div v-if="(list && list.length > 0) || onFlag">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height: 95vh;">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div
            class="searchList"
            v-for="(item, index) in list"
            :key="index"
            @click="detail(item.id)"
          >
            <div class="item">
              <div class="img">
                <img :src="item.tombPhoto" />
              </div>
              <div class="content">
                <!-- <div>{{ item.number }}</div> -->
                <div class="jsitem">
                  {{ item.oweArea.areaName }}  {{ item.tombNum }} 
                </div>
                <div>
                  <span>墓碑</span>{{ item.oweStele.steleName }} 
                </div>

                <div :key="index2" v-for="(item2, index2) in item.members">
                  <div>{{ item2.userName }} {{ item2.userGender }}</div>
                  
                </div>
                
                <!-- <div><span>墓穴：</span>{{ item.tombHole }}</div> -->
              </div>
            </div>
            <div v-if="index < list.length - 1" class="line"></div>
          </div>
        </van-list>
      </van-pull-refresh>
      <div v-if="noDataFlag" style="text-align:center;line-height:1rem;">没有更多数据~</div>
    </div>
    <div v-else class="searchText">
      <div>
        <p v-if="keyword">未找到和关键词匹配的信息~</p>
        <p v-else>请输入关键词~</p>
      </div>
      <div class="kefu">
        <i class="iconfont">&#xec2e;</i
        ><a href="https://work.weixin.qq.com/kfid/kfc10fd463b85635b1b" style="color:#fff;">客服</a>
      </div>
    </div>

    <copyright></copyright>
  </div>
</template>

<script>
import jisaoSearch from './Search'
import copyright from './Copyright'
import bus from '../../common/bus'
export default {
  name: 'jisaoList',
  components: {
    jisaoSearch,
    copyright,
  },
  data() {
    return {
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
      page: 1,
      keyword: '',
      size: 2,
      noDataFlag: false,
      onFlag: false,
    }
  },
  created() {
    // console.log(this.$route.params.keyword)
    bus.$off('keyword')
    bus.$on('keyword', msg => {
      console.log(msg)
      this.page = 1
      this.list = []
      if (localStorage.getItem('keyword')) {
        this.keyword = localStorage.getItem('keyword')
      }

      this.queryTombPage()
      document.querySelector('.jisaoList').scrollTop = 0
    })
  },
  mounted() {
    this.keyword = ''
    this.list = []
    if (localStorage.getItem('keyword')) {
      this.keyword = localStorage.getItem('keyword')
    }

    this.queryTombPage()
    document.querySelector('.jisaoList').scrollTop = 0
  },
  methods: {
    queryTombPage() {
      if (!this.keyword) {
        this.list = []
        return
      }
      if (this.page == 1) this.list = []
      this.onFlag = true
      var that = this
      this.$queryPage(
        '/api/memtomb/queryTomb',
        { keyword: that.keyword, page: that.page, size: that.size },
        // [
        //   'id', // ID
        //   'areaId', // 区域ID
        //   'oweArea.areaName', // 区域名称
        //   'oweArea.areaPhoto', // 区域图片
        //   'oweArea.areaVideo', // 区域视频
        //   'steleId', // 墓碑ID
        //   'oweStele.steleName', // 墓碑名称
        //   'oweStele.firstPhoto', // 墓碑图片
        //   'tombNum', // 行号
        //   'tombPhoto', // 图片
        //   'ownUser', // 拥有人
        //   'expiryDate', // 过期时间
        //   'members',  // 成员
        // ],
        function(res) {
          // {"data":[{"id":10009,"areaId":10001,"oweArea":{"areaName":"东区","areaPhoto":"/files/20221209/1670573085908.jpg","areaVideo":"/files/20221218/1671368538461.mp4"},"steleId":2,"oweStele":{"steleName":"艺术墓"},"tombNum":"qwe","tombPhoto":"/files/20230109/1673269623411.jpg","ownUser":"qwe","expiryDate":"2022-12-13 00:00:00","members":"[{\"userGender\":\"男\",\"userName\":\"赵一\"},{\"userGender\":\"男\",\"userName\":\"wqe\"}]"}],"total":1}
          that.onFlag = false
          if (res['data'].length > 0) {
            for(var index in res['data']){
              if(res['data'][index]['members']){
                res['data'][index]['members'] = JSON.parse(res['data'][index]['members'])
              }
            }
            that.$fill(that.list, res['data'])
            if (res['data'].length + (that.page - 1) * that.size < res['total']) {
              that.loading = false
              that.page++
            } else {
              that.stop = true
              that.finished = true
              that.loading = false
              that.isLoading = false
              if (that.page == 1) {
                that.noDataFlag = false
              } else {
                that.noDataFlag = true
              }
            }
          } else {
            that.finished = true
            that.loading = false
            that.isLoading = false
            if (that.page == 1) {
              that.list = []
            } else {
              that.$notify({
                message: '没有更多数据~',
                color: '#ad0000',
                background: '#ffe1e1',
              })
            }
          }
        }
      )
    },
    detail(id) {
      this.$router.push({ path: '/jisao/detail' + id })
    },
    onLoad() {
      let that = this
      setTimeout(() => {
        if (that.isLoading) {
          that.isLoading = false
        }
        if (this.page > 1) {
          this.queryTombPage()
        }
      }, 500)
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.onLoad()
    },
  },
}
</script>

<style>
.jisaoList .item {
  display: flex;
  padding: 0 20px;
  margin: 0 auto;
}
.jisaoList .item .content {
  line-height: 0.7rem;
  padding-left: 0.27rem;
}
.jisaoList .item .content div {

   font-size: 16px;
}
.jsitem {
  font-weight: bold;
  font-size: 18px;

}

.jisaoList .item .img {
  width: 40%;
}
.jisaoList .item .img img {
  width: 100%;
  margin-top: 5%;
}
.jisaoList .searchTitle {
  padding: 0 20px;
  font-size: 18px;
  color: #2c3e50;
}
.jisaoList .searchList {
  margin: 0.3rem auto;
  padding-bottom: 0.3rem;
}
.jisaoList .searchList .line {
  border-bottom: 1px solid #ccc;
  width: 90%;
  margin: 0 auto;
  height: 0.5rem;
}
.jisaoList .searchText {
  margin: 120px auto;
  min-height: 30vh;
  padding: 0 20px;
  line-height: 40px;
  text-align: center;
}
.jisaoList .kefu {
  background: rgb(116, 199, 160);
  width: 80px;
  border-top-left-radius: 2500px;
  border-bottom-left-radius: 2500px;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  position: fixed;
  right: 0;
  top: 80px;
}
.jisaoList .kefu i {
  margin-right: 5px;
}
</style>
